import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton'; // @ts-expect-error importing from JS file

import { fetchOverview } from 'AdsUI/actions/AdAccountsActions';
import { createOfflineEvent, fetchEventList // @ts-expect-error importing from JS file
} from 'AdsUI/actions/EventSettingsActions'; // @ts-expect-error importing from JS file

import { postTimedNotification } from 'AdsUI/actions/NotificationActions';
import { EVENT_CREATION_ERROR_TYPES, EVENT_CREATION_RESPONSE_MESSAGE_KEYWORDS // @ts-expect-error importing from JS file
} from 'AdsUI/lib/Constants';
import { fetchAdAccounts, formHasErrors, generateNewEventData, recordSubmissionMetrics, validateDataTermsWereAccepted } from './GoogleECLCSEventCreationButton.utils';

/**
 * Button for creating a Google EC LCS event.
 */
const GoogleECLCSEventCreationButton = ({
  accountsWithoutBusinessManager,
  eventOptions,
  locked,
  setHasIncorrectBusinessManagerPermissions,
  setShowErrors,
  toggleIsOpen
}) => {
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    if (formHasErrors(eventOptions, accountsWithoutBusinessManager)) {
      setShowErrors(true);
      return;
    } // Cast because `formHasErrors` successfully validated the event options


    const validatedEventOptions = eventOptions;
    setLoading(true); // If user selected data terms after opening the form, then we will only be able to tell with fresh account data

    const accounts = await fetchAdAccounts(() => dispatch(fetchOverview()));

    if (!validateDataTermsWereAccepted(accounts, validatedEventOptions.selectedAdAccount.adAccount.accountId)) {
      setLoading(false);
      setFailed(true);
      setShowErrors(true);
      return;
    }

    const newEventData = generateNewEventData(validatedEventOptions);
    const {
      network,
      accountId
    } = validatedEventOptions.selectedAdAccount.adAccount;

    try {
      await dispatch(createOfflineEvent(network, accountId, newEventData));
      dispatch(postTimedNotification({
        id: 'create-offline-event-success',
        type: 'success',
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "events.creation.banners.success",
          options: {
            eventName: newEventData.eventName
          }
        })
      }, 4000));
      await dispatch(fetchEventList());
      recordSubmissionMetrics(network, validatedEventOptions);
      setLoading(false);
      toggleIsOpen();
    } catch (_error) {
      // Declaring a type on a caught error is not yet supported by our parsers
      const error = _error;
      setFailed(true);
      const errorType = error.cause && error.cause.errorType || '';
      const errorMessage = error.cause && error.cause.message || '';

      if (errorType === EVENT_CREATION_ERROR_TYPES.APP_SCOPE && errorMessage.includes(EVENT_CREATION_RESPONSE_MESSAGE_KEYWORDS.MODIFY_OFFLINE_CONVERSION_DATA_SETS)) {
        setShowErrors(true);
        setHasIncorrectBusinessManagerPermissions(true);
      }

      setLoading(false);
    }
  };

  return /*#__PURE__*/_jsx(UILoadingButton, {
    use: "primary",
    disabled: locked,
    onClick: handleSubmit,
    loading: loading,
    failed: failed,
    "data-test-id": "google-ec-lcs-create-event-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "events.creation.button"
    })
  });
};

export default GoogleECLCSEventCreationButton;